module.exports = __webpack_public_path__ + "img/ban_facebook_immo_1121.e5b68867.png";